import type { Layout } from "./layout";

export class Input {
  pointerDown = false;
  pointerX = 0;
  pointerY = 0;
  hasTap = false;
  tapX = 0;
  tapY = 0;
  hasRelease = false;
  releaseX = 0;
  releaseY = 0;
  actionPressed = false;
  actionReleased = false;
  actionHeld = false;
  muted = false;
  onCheatKey: ((key: string) => void) | null = null;

  private _spaceDown = false;
  private _prevSpaceDown = false;
  private _prevPointerDown = false;

  constructor(
    readonly canvas: HTMLCanvasElement,
    readonly layout: Layout,
  ) {
    const onDown = (e: PointerEvent): void => {
      this.pointerDown = true;
      this.hasTap = true;
      this.updatePos(e);
      this.tapX = this.pointerX;
      this.tapY = this.pointerY;
    };
    const onMove = (e: PointerEvent): void => {
      this.updatePos(e);
    };
    const onUp = (_e: PointerEvent): void => {
      this.pointerDown = false;
      this.hasRelease = true;
      this.releaseX = this.pointerX;
      this.releaseY = this.pointerY;
    };
    const onKey = (e: KeyboardEvent): void => {
      if (e.code === "Space" || e.key === " ") {
        this._spaceDown = e.type === "keydown";
        if (e.type === "keydown") e.preventDefault();
      }
      if ((e.key === "m" || e.key === "M") && e.type === "keydown") {
        this.muted = !this.muted;
      }
      if (this.onCheatKey) {
        this.onCheatKey(e.key);
      }
    };
    canvas.addEventListener("pointerdown", onDown);
    canvas.addEventListener("pointermove", onMove);
    canvas.addEventListener("pointerup", onUp);
    canvas.addEventListener("pointercancel", onUp);
    window.addEventListener("keydown", onKey);
    window.addEventListener("keyup", onKey);
  }

  private updatePos(e: PointerEvent): void {
    const rect = this.canvas.getBoundingClientRect();
    this.pointerX = (e.clientX - rect.left) / this.layout.scale;
    this.pointerY = (e.clientY - rect.top) / this.layout.scale;
  }

  update(): void {
    const actionDown = this._spaceDown || this.pointerDown;
    this.actionPressed = actionDown && !this._prevActionDown;
    this.actionReleased = !actionDown && this._prevActionDown;
    this.actionHeld = actionDown;
    this._prevActionDown = actionDown;
  }

  private _prevActionDown = false;

  clearFrameEvents(): void {
    this.hasTap = false;
    this.hasRelease = false;
    this.actionPressed = false;
    this.actionReleased = false;
  }

  pollGamepad(): boolean {
    const gamepads = navigator.getGamepads();
    if (!gamepads) return false;
    for (let i = 0; i < gamepads.length; i++) {
      const gp = gamepads[i];
      if (!gp) continue;
      if (gp.buttons[0]?.pressed) return true;
      for (let b = 0; b < gp.buttons.length; b++) {
        if (gp.buttons[b].pressed) return true;
      }
    }
    return false;
  }
}
